import { NOTIF_DURATION } from '@aibees/shared/constants';
import { Collapse, IconButton } from '@mui/material';
import {
  SnackbarProvider as NotistackProvider,
  closeSnackbar,
} from 'notistack';
import { PropsWithChildren, useRef } from 'react';
import { Icon } from '../icon';
import { useSettingsContext } from '../settings';
import { CompleteSnackbar } from './components/complete-snackbar';
import { ProgressSnackbar } from './components/progress-snackbar';
import { WarningSnackbar } from './components/warning-snackbar';
import { StyledIcon, StyledNotistack } from './styles';

const ANCHOR_ORIGIN = {
  vertical: 'top' as const,
  horizontal: 'right' as const,
};

export default function SnackbarProvider({ children }: PropsWithChildren) {
  const settings = useSettingsContext();

  const isRTL = settings.themeDirection === 'rtl';

  const notistackRef = useRef<any>(null);

  return (
    <NotistackProvider
      ref={notistackRef}
      maxSnack={5}
      preventDuplicate
      autoHideDuration={NOTIF_DURATION}
      TransitionComponent={isRTL ? Collapse : undefined}
      variant="success" // Set default variant
      anchorOrigin={ANCHOR_ORIGIN}
      iconVariant={{
        info: (
          <StyledIcon color="info">
            <Icon size={20} name="info-fill" />
          </StyledIcon>
        ),
        success: (
          <StyledIcon color="success">
            <Icon name="check-circle" />
          </StyledIcon>
        ),
        complete: (
          <StyledIcon color="success">
            <Icon name="check-circle" />
          </StyledIcon>
        ),
        warning: (
          <StyledIcon color="warning">
            <Icon name="alert-fill" />
          </StyledIcon>
        ),
        error: (
          <StyledIcon color="error">
            <Icon name="danger" />
          </StyledIcon>
        ),
        progress: (
          <StyledIcon color="info">
            <Icon name="change-circle-outline" />
          </StyledIcon>
        ),
        waiting: (
          <StyledIcon color="primary">
            <Icon color="primary.500" name="change-circle-outline" />
          </StyledIcon>
        ),
      }}
      Components={{
        default: StyledNotistack,
        info: StyledNotistack,
        success: StyledNotistack,
        warning: WarningSnackbar,
        error: StyledNotistack,
        progress: ProgressSnackbar,
        complete: CompleteSnackbar,
        waiting: CompleteSnackbar,
      }}
      // with close as default
      action={(snackbarId) => (
        <IconButton
          size="small"
          onClick={() => closeSnackbar(snackbarId)}
          sx={{ p: 0.5 }}
        >
          <Icon name="close" size={18} />
        </IconButton>
      )}
    >
      {children}
    </NotistackProvider>
  );
}
